import React from "react";
import { useLocation } from "react-router-dom"; // To get passed data
import { Box, Typography, Card, CardContent, Grid } from "@mui/material";

const GPSDetails = () => {
    const location = useLocation();
    let gpsData = location.state?.gpsData || [];

    // ✅ Ensure gpsData is always an array
    if (!Array.isArray(gpsData)) {
        console.warn("GPS Data received is not an array. Converting to array:", gpsData);
        gpsData = [gpsData]; // Wrap it in an array
    }

    return (
        <Box sx={{ p: 3 }}>
            <Typography variant="h5" sx={{ mb: 3 }}>📍 GPS Data</Typography>

            {/* GPS Data Cards */}
            <Grid container spacing={3}>
                {gpsData.length > 0 ? (
                    gpsData.map((point, index) => (
                        <Grid item xs={12} sm={6} key={index}>
                            <Card sx={{ boxShadow: 3, borderRadius: 2, p: 2 }}>
                                <CardContent>
                                    <Typography variant="body2" color="textSecondary"><strong>Client:</strong> {point.client.shortName}</Typography>
                                    <Typography variant="h6">🆔 Shipment ID: {point.shipmentId}</Typography>
                                    <Typography variant="body1"><strong>Shipment Code:</strong> {point.shipmentCode}</Typography>
                                    <Typography variant="body2" color="textSecondary"><strong>Status:</strong> {point.status}</Typography>
                                    <Typography variant="body2" color="textSecondary"><strong>From:</strong> {point.from}</Typography>
                                    <Typography variant="body2" color="textSecondary"><strong>To:</strong> {point.to}</Typography>

                                </CardContent>
                            </Card>
                        </Grid>
                    ))
                ) : (
                    <Typography>No GPS data available.</Typography>
                )}
            </Grid>

        </Box>
    );
};

export default GPSDetails;
